import { CatalogObjectReport } from './catalog-object-report';
import { CompanyReport } from './company-report';
import { LicencesReport } from './licences-report';
import { UserReport } from './user-report';

/**
 * The Report model manages the user and company data about storage, streaming and credits .
 */

export interface Report {
    company: CompanyReport;
    licences: LicencesReport;
    [key: string]: UserReport | CompanyReport | LicencesReport;
}

export interface ReportData {
    id: string;
    label: string;
    value: number;
    maxValue: number;
    percentage: number;
    unit?: string; // If there is no unit it will be apply 'bytes',
    objectList?: CatalogObjectReport[];
}

export const ReportDataId = {
    TRANSFER: 'transfer',
    SOTRAGE: 'storage',
    PROCESSING: 'processing',
};

export type ReportDataIdType = typeof ReportDataId;
